<template>
  <div>
    <div
      class="go-bx-menu pd-10 bd-b bg-gray-100 ht-50 d-flex align-items-center"
      style="overflow: visible"
    >
      <div class="dropdown dropdown-icon wd-100p" v-if="boxMenu.length">
        <div
          data-toggle="dropdown"
          class="d-flex align-items-center"
          role="button"
        >
          <div
            class="tx-sans tx-uppercase tx-medium tx-11 tx-spacing-1 tx-color-03 pd-l-5"
          >
            <feather
              type="chevron-down"
              class="ht-15-f wd-15-f mg-r-5"
            ></feather
            >Бүрдэлүүд
          </div>
          <button
            class="btn btn-outline-light btn-xs btn-uppercase mg-l-auto"
            href="javascript:void(0)"
          >
            шинэ
            <feather type="plus" class="ht-15-f wd-15-f mg-l-5"></feather>
          </button>
        </div>
        <ul class="dropdown-menu dropdown-menu-box tx-13" role="menu">
          <li
            @click="boxmodalShow(m)"
            class="dropdown-item"
            v-for="(m, i) in boxMenu"
            :key="i"
            role="button"
          >
            <feather type="plus"></feather>
            <span>{{ m.title }}</span>
          </li>
        </ul>
      </div>
      <div class v-else>
        <div
          class="tx-sans tx-uppercase tx-medium tx-11 tx-spacing-1 tx-color-03 pd-l-5"
        >
          <!-- <feather type="chevron-down" class="ht-15-f wd-15-f mg-r-5"></feather> -->
          Бүрдэлүүд
        </div>
      </div>
    </div>
    <div class="pd-10" :style="`height: ${scrollHeight}px`">
      <!-- <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Бүрдэлүүд</label> -->
      <nav class="nav nav-sidebar tx-13">
        <template v-if="obj.data.task.b.length > 0">
          <a
            @click="$emit('on-load-box', bx)"
            class="nav-link d-flex align-items-center"
            v-for="(bx, i) in obj.data.task.b"
            :key="i"
            role="button"
            :class="{ active: bx.id == activeBox.id }"
          >
            <!-- <feather type="folder" class="ht-10-f wd-10-f mg-r-5"></feather> -->
            <!-- <i
              v-if="bx.id == activeBox.id"
              class="icon ion-md-folder-open tx-14 mg-r-10"
            ></i>
            <i v-else class="icon ion-md-folder tx-14 mg-r-10"></i> -->
            <div class="dropdown">
              <div data-toggle="dropdown" role="button">
                <feather type="settings"></feather>
              </div>
              <ul class="dropdown-menu dropdown-menu-box tx-13" role="menu">
                <li @click="boxmodalRename(bx)" class="dropdown-item" role="button" >
                  <span>Засах</span>
                </li>
                <li @click="$emit('box-delete', { id: bx.id, module: 'box' })" class="dropdown-item" role="button" >
                  <span class="tx-danger">Устгах</span>
                </li>
              </ul>
            </div>
            <div>
              <div class="lh-1">{{ bx.nm }}</div>
              <div
                v-if="bx.otName.toUpperCase() != bx.nm.toUpperCase()"
                class="tx-8 font-weight-light text-muted text-uppercase"
              >
                [{{ bx.otName }}]
              </div>
            </div>

            
            <div class="d-flex mg-l-auto align-items-center">
              <span class="badge badge-secondary text-white">{{ getBoxCount(bx) }}</span>
            </div>
          </a>
        </template>
        <div v-else class="container d-flex justify-content-center ht-90p">
          <div
            class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
          >
            <div class="wd-80p wd-sm-300 mg-b-15 text-center">
              <img src="assets/svg/boxempty.svg" alt class="img-fluid wd-60p" />
            </div>
            <h4 class="tx-20 tx-sm-24 text-muted"></h4>
            <p class="tx-color-03 mg-b-30 tx-center">Бүрдэл үүсээгүй байна</p>
          </div>
        </div>
      </nav>
    </div>

    <b-modal
      v-model="curBox.modal"
      title="Бүрдэл"
      scrollable
      no-fade
      centered
      @hide="onModalHide"
    >
      <b-form v-if="curBox.rename">
        <b-form-group label="Бүрдэлийн нэр:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="curBox.box.nm"
            placeholder="Бичнэ үү"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Эрэмбэ:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="curBox.box.ord"
            placeholder="Бичнэ үү"
            required type="number"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="curBox.box.objectTypeId == 502"
          label="Бие даалт эхлэх:"
        >
          <DatePicker
            v-model="curBox.box.d1"
            placeholder="Огноо сонгоно уу"
            type="date"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
            style="width: 100%"
          ></DatePicker>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 502"
          label="Бие даалт дуусах:"
        >
          <DatePicker
            v-model="curBox.box.d2"
            placeholder="Огноо сонгоно уу"
            type="date"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
            style="width: 100%"
          ></DatePicker>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 502 || curBox.box.objectTypeId == 524 || curBox.box.objectTypeId == 580"
          :label="getTitle(curBox.box.objectTypeId)"
        >
          <simple-uploader
            :propObjectId="6"
            :propObjectTypeId="6"
            @on-success="fileUploadedSetting"
            class="wd-100p"
          >
            <div slot="trigger" class="wd-100p">
              <a
                v-if="curBox.box.attachId == 0 || curBox.box.attachId == null"
                class="dropdown-item"
                >Компютероос хуулах</a
              >
              <div v-else class="btn-group wd-100p">
                <div
                  class="btn btn-outline-success"
                  @click.stop="$emit('on-attach', curBox.box.attachId)"
                >
                  <feather type="eye"></feather>Файл харах
                </div>
                <div
                  class="btn btn-danger"
                  @click.prevent.stop="curBox.box.attachId = null"
                >
                  <feather type="x"></feather>Салгах
                </div>
              </div>
              <!-- <a v-else class="dropdown-item">                
                <img    :src="`${boxAttach.uploadedUrl}?w=160&h=120&mode=crop`" />
              </a>-->
            </div>
          </simple-uploader>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 502 "
          label="Бие даалт тухай:"
        >
          <summernote
            v-model="curBox.box.info"
            :text="curBox.box.info"
          ></summernote>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 615"
          label="Заавар зөвлөмж:"
        >
          <summernote
            v-model="curBox.box.info"
            :text="curBox.box.info"
          ></summernote>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 615"
          label="Код:"
        >

        <b-form-input
            id="input-2"
            v-model="curBox.box.flag"
            placeholder="Код..."
            required
          ></b-form-input>

        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 397"
          label="Харагдац:"
        >
         <Select v-model="curBox.box.flag" clearable class="wd-100p">
          <Option v-for="(f,i) in boxFlags" :key="i" :value="f.id" :label="f.title"></Option>
         </Select> 
        </b-form-group>
      </b-form>
      <b-form v-else>
        <b-form-group label="Бүрдэлийн нэр:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="curBox.obj.title"
            placeholder="Бичнэ үү"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Эрэмбэ:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="curBox.obj.ord"
            placeholder="Бичнэ үү"
            required type="number"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="curBox.obj.objectTypeId == 502"
          label="Бие даалт эхлэх:"
        >
          <DatePicker
            v-model="curBox.obj.d1"
            placeholder="Огноо сонгоно уу"
            type="date"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
            style="width: 100%"
          ></DatePicker>
        </b-form-group>
        <b-form-group
          v-if="curBox.obj.objectTypeId == 502"
          label="Бие даалт дуусах:"
        >
          <DatePicker
            v-model="curBox.obj.d2"
            placeholder="Огноо сонгоно уу"
            type="date"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
            style="width: 100%"
          ></DatePicker>
        </b-form-group>
        <b-form-group
          v-if="curBox.obj.objectTypeId == 502 || curBox.obj.objectTypeId == 530"
          :label="curBox.obj.objectTypeId==502?'Бие даалт файл:':'Загвар файл'"
        >
          <simple-uploader
            :propObjectId="6"
            :propObjectTypeId="6"
            @on-success="fileUploadedSetting"
            class="wd-100p"
          >
            <div slot="trigger" class="wd-100p">
              <a
                v-if="curBox.obj.attachId == 0 || curBox.obj.attachId == null"
                class="dropdown-item"
                >Компьютероос хуулах</a
              >
              <a v-else class="dropdown-item">
                <img :src="`${boxAttach.uploadedUrl}?w=160&h=120&mode=crop`" />
              </a>
            </div>
          </simple-uploader>
        </b-form-group>
        <b-form-group
          v-if="curBox.obj.objectTypeId == 502"
          label="Бие даалт тухай:"
        >
          <summernote
            v-model="curBox.obj.info"
            :text="curBox.obj.info"
          ></summernote>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 615"
          label="Заавар зөвлөмж:"
        >
          <summernote
            v-model="curBox.box.info"
            :text="curBox.box.info"
          ></summernote>
        </b-form-group>
        <b-form-group
          v-if="curBox.box.objectTypeId == 615"
          label="Код:"
        >

        <b-form-input
            id="input-2"
            v-model="curBox.box.flag"
            placeholder="Код..."
            required
          ></b-form-input>

        </b-form-group>
        <b-form-group
          v-if="curBox.obj.objectTypeId == 397"
          label="Харагдац:"
        >
         <Select v-model="curBox.obj.flag" clearable class="wd-100p">
          <Option v-for="(f,i) in boxFlags" :key="i" :value="f.id" :label="f.title"></Option>
         </Select> 
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button @click="onReset" variant="danger">Болих</b-button>
        <b-button @click="onSubmit" variant="primary">Хадгалах</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { DatePicker, Select, Option } from "element-ui";

import { request } from "@/api/all";
export default {
  components: {
    DatePicker, Select, Option,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    b: {
      type: Object,
      default: () => {}
    },
    activeBox: {
      type: Object,
      default: () => {}
    },
    detailSettingProp: {
      type: Object,
      default: {
        hideToolbar: false
      }
    }
  },
  data() {
    return {
      boxFlags: [
        {id: 1, title: 'Цэгтэй жагсаалт' },
        {id: 2, title: 'Кардан' },
        {id: 3, title: 'Хавчуурган' },
      ],
      boxMenu: [],
      curBox: {
        modal: false,
        rename: false,
        box: {
          id: null,
          nm: "",
          ord: 0,
          objectTypeId: null,
          d1: null,
          d2: null,
          info: "",
          attachId: null,
          flag: null,
        },
        obj: {
          defaultBoxName: "",
          objectTypeId: null,
          title: "",
          ord: 0,
          d1: null,
          d2: null,
          info: "",
          attachId: null
        }
      },
      boxAttach: {
        uploadedUrl: ""
      },
      scrollHeight: 0
    };
  },
  mounted() {
    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
  },
  methods: {
    getTitle(ot){
      let rv= 'Хавсралт';
      if(ot == 502){
        rv = 'Бие даалт файл';
      }else if(ot == 524){
        rv = 'Купон файл';
      }
      return rv;
      // curBox.box.objectTypeId == 502 || curBox.box.objectTypeId == 524 || curBox.box.objectTypeId == 580
    },
    getWindowHeight() {
      this.scrollHeight =
        window.innerHeight - (this.detailSettingProp.hideToolbar ? 50 : 110);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      request({
        api: { method: "GET", url: "Box/getBoxMenu" },
        params: {
          taskId: this.obj.data.task.id
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log(res.data);
          this.boxMenu = res.data.menus;
          this.$emit("on-box-menu-loaded", this.boxMenu.length);
        }
      });
    },
    boxmodalShow(box) {
      //console.log(box);
      this.curBox.obj = box;
      this.curBox.modal = true;
    },
    boxmodalRename(box) {
      //console.log(box);
      this.curBox.box = {
        id: box.id,
        nm: box.nm,
        ord: box.ord,
        d1: box.d1,
        d2: box.d2,
        objectTypeId: box.ot,
        info: box.info,
        flag: box.flag,
        attachId: box.attachId
      };
      this.curBox.rename = true;
      this.curBox.modal = true;
    },
    onReset() {
      this.curBox.obj = {
        defaultBoxName: "",
        objectTypeId: null,
        title: "",
        d1: null,
        d2: null,
        info: "",
        attachId: null
      };
      this.curBox.box = {
        nm: "",
        ord: null,
        id: null,
        objectTypeId: null,
        d1: null,
        d2: null,
        info: "",
        attachId: null
      };
      this.curBox.modal = false;
    },
    onSubmit() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _url = "Box/PostInherited";
      let _data = {
        box: this.curBox.obj.title,
        ord: this.curBox.obj.ord,
        taskId: this.obj.data.task.id,
        objectTypeId: this.curBox.obj.objectTypeId,
        d1: this.curBox.obj.d1,
        d2: this.curBox.obj.d2,
        info: this.curBox.obj.info,
        attachId: this.curBox.obj.attachId,
        flag: this.curBox.obj.flag,
      };
      if (this.curBox.rename) {
        _url = "Box/Rename";
        _data = {
          id: this.curBox.box.id,
          nm: this.curBox.box.nm,
          ord: parseInt(this.curBox.box.ord, 10),
          d1: this.curBox.box.d1,
          d2: this.curBox.box.d2,
          info: this.curBox.box.info,
          attachId: this.curBox.box.attachId,
          flag: this.curBox.box.flag
        };
      }

      request({
        api: { method: "POST", url: _url },
        data: _data,
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$emit(
            "on-reload",
            this.curBox.rename ? this.curBox.box.id : res.data.box.id
          );
          this.onReset();
        }
      });
    },
    getBoxCount(box) {
      let rv = "";
      if (box.attachCount > 0) rv = box.attachCount;
      else if (box.formCount > 0) rv = box.formCount;
      else rv = box.taskCount;
      return rv;
    },
    onModalHide() {
      this.onReset();
    },
    fileUploadedSetting(e) {
      this.boxAttach = e;
      this.curBox.obj.attachId = e.uploadedAttachmentId;
      this.curBox.box.attachId = e.uploadedAttachmentId;
    }
  }
};
</script>

<style>
.dropdown-menu-box {
  transform: translate3d(0px, 35px, 0px) !important;
}
</style>
